<section class="clean-pricing-section">
  <div class="container">

    <div class="sales-hero">
      <!-- <span class="badge-pill fadeInDown" appVisibility>Estrategia Comercial 2026</span> -->
      <h1 class="main-title fadeInDown" appVisibility>Tu logística, más inteligente y económica</h1>
      <p class="subtitle fadeInUp" appVisibility>
        Las <strong>Guías Web</strong> son envíos que compras por adelantado para usar cuando quieras.
        Ideales para E-commerce, oficinas y negocios que buscan congelar tarifas y ahorrar tiempo.
      </p>

      <div class="benefits-grid">
        <div class="benefit-item fadeInUp" appVisibility>
          <div class="icon-circle">📉</div>
          <h3>Reduce Costos Operativos</h3>
          <p>Ahorra hasta un 30% comparado con envíos individuales de mostrador. Congela el precio por 1 año.</p>
        </div>
        <div class="benefit-item fadeInUp" appVisibility>
          <div class="icon-circle">⚡</div>
          <h3>Adiós a las Filas</h3>
          <p>Genera tus guías desde tu oficina o casa. Solo llega a mostrador a entregar (Drop-off rápido).</p>
        </div>
        <div class="benefit-item fadeInUp" appVisibility>
          <div class="icon-circle">📊</div>
          <h3>Control Total</h3>
          <p>Administra tus envíos desde un panel web. Historial, rastreo y reimpresión en un solo lugar.</p>
        </div>
      </div>
    </div>

    <div class="pricing-area" id="pricing-area">
      <div class="section-divider fadeIn" appVisibility>
        <span>Elige tu volumen anual</span>
      </div>

      <div class="tabs-wrapper">
        <div class="tabs-container fadeInUp" appVisibility>
          <button class="tab-pill" [class.active]="activeTab === '1kg'" (click)="setTab('1kg')">📦 Hasta 1 KG</button>
          <button class="tab-pill" [class.active]="activeTab === '5kg'" (click)="setTab('5kg')">📦 Hasta 5 KG</button>
          <button class="tab-pill" [class.active]="activeTab === 'heavy'" (click)="setTab('heavy')">{{
            heavyTabLabel}}</button>
        </div>
      </div>

      <div class="cards-scroller">
        <div class="card-wrapper fadeInUp" *ngFor="let item of currentPackages" appVisibility>
          <article class="price-card" [class.popular-card]="item.isPopular" [class.not-popular-card]="!item.isPopular">

            <div class="card-badge main-badge" *ngIf="item.savings || item.isPopular">
              {{ item.savings || 'Más Vendido' }}
            </div>

            <div class="card-badge normal-badge" *ngIf="item.name === 'Crecimiento'"
              style="text-transform: none; font-size: 0.55rem; width: auto; text-align: center; line-height: 1.1; top: 17px; left: 50%; right: auto; transform: translateX(-50%); white-space: nowrap; background: #ffe0d6; color: #f05a28; padding: 4px 10px; border-radius: 12px; border: none;">
              8 de cada 10 clientes eligen este paquete
            </div>

            <div class="card-top">
              <h3 class="pkg-name">{{ item.name }}</h3>
              <div class="pkg-qty">
                <span>{{ item.quantity }} Guías</span>
              </div>
              <div class="pkg-weight-desc">
                {{ item.weightDesc === '10 kg' ? 'Carga Pesada +10kg' : 'Hasta ' + item.weightDesc }}
              </div>
            </div>

            <div class="card-price">
              <p class="label">Costo unitario</p>
              <div class="big-price">
                <span class="currency">$</span>{{ item.priceUnit | number:'1.0-2' }}
              </div>
              <p class="total-price">Inversión: ${{ item.totalPrice | number:'1.0-2' }}</p>
            </div>

            <div class="card-actions">
              <!-- <a [href]="item.link" class="btn-select">
                Comprar Pack
              </a> -->
              <a [routerLink]="['/guias-web']" [queryParams]="{ sku: item.sku }" class="btn-select">
                Comprar Pack
              </a>
            </div>

            <div class="card-features">
              <span><i class="check-icon">✓</i> Vigencia 12 meses</span>
              <span><i class="check-icon">✓</i> Recolección Incluida</span>
              <button class="btn-details" (click)="openDetails(item)">
                Ver detalles
              </button>
            </div>

          </article>
        </div>
      </div>
    </div>


  </div><!-- Fin .container -->

  <!-- MODAL DE DETALLES -->
  <div class="modal-overlay" *ngIf="isModalOpen" (click)="closeDetails()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <div class="header-top">
          <h2 class="modal-title">Detalles del paquete</h2>
        </div>
        <p class="modal-subtitle">Revisa la información incluida antes de continuar</p>
        <button class="btn-close" (click)="closeDetails()">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>

      <div class="modal-body" *ngIf="selectedPkg">
        <section class="info-section">
          <h3>Qué incluye este paquete</h3>
          <div class="info-card">
            <div class="info-item">
              <i class="fa-solid fa-box icon package-icon"></i>
              <div class="info-row">
                <span class="label">Paquete:</span>
                <span class="value">{{ selectedPkg.name }}</span>
              </div>
            </div>
            <div class="info-item">
              <i class="fa-solid fa-layer-group icon qty-icon"></i>
              <div class="info-row">
                <span class="label">Cantidad:</span>
                <span class="value">{{ selectedPkg.quantity }} guías / envíos</span>
              </div>
            </div>
            <div class="info-item">
              <i class="fa-solid fa-weight-hanging icon weight-icon"></i>
              <div class="info-row">
                <span class="label">Peso máximo por envío:</span>
                <span class="value">{{ selectedPkg.weightDesc }}</span>
              </div>
            </div>
            <div class="info-item">
              <i class="fa-solid fa-clock icon time-icon"></i>
              <div class="info-row">
                <span class="label">Vigencia:</span>
                <span class="value">12 meses</span>
              </div>
            </div>

            <div class="divider"></div>

            <div class="info-item">
              <i class="fa-solid fa-hand-holding-dollar icon cost-icon"></i>
              <div class="info-row">
                <span class="label">Costo unitario:</span>
                <span class="value">${{ selectedPkg.priceUnit | number:'1.2-2' }} MXN</span>
              </div>
            </div>
            <div class="info-item">
              <i class="fa-solid fa-truck icon truck-icon"></i>
              <div class="info-row">
                <span class="label">Recolección:</span>
                <span class="value">Incluida</span>
              </div>
            </div>
            <div class="info-item">
              <i class="fa-solid fa-house-chimney icon house-icon"></i>
              <div class="info-row">
                <span class="label">Entrega:</span>
                <span class="value">Servicio a domicilio</span>
              </div>
            </div>
            <div class="info-item">
              <i class="fa-solid fa-receipt icon iva-icon"></i>
              <div class="info-row">
                <span class="label">IVA:</span>
                <span class="value">Incluido en el precio</span>
              </div>
            </div>
            <div class="info-item">
              <i class="fa-solid fa-award icon shield-icon"></i>
              <div class="info-row">
                <span class="label">Garantía:</span>
                <span class="value">Según contrato de adhesión</span>
              </div>
            </div>
            <!-- <div class="info-item">
              <i class="fa-solid fa-xmark icon danger-icon"></i>
              <div class="info-row">
                <span class="label">Maniobras adicionales:</span>
                <span class="value">No incluidas</span>
              </div>
            </div> -->
          </div>
        </section>

        <section class="conditions-section">
          <h3>Condiciones del servicio</h3>
          <ul class="conditions-list">
            <li><i class="fa-solid fa-check"></i> Los costos incluyen IVA</li>
            <li><i class="fa-solid fa-check"></i> Servicio sujeto a disponibilidad de sucursales</li>
            <li><i class="fa-solid fa-check"></i> Aplica contrato de adhesión</li>
            <li><i class="fa-solid fa-xmark"></i> No incluye maniobras adicionales</li>
          </ul>
          <a href="#" class="contract-link">Ver contrato de adhesión</a>
        </section>
      </div>

      <div class="modal-footer" *ngIf="selectedPkg">
        <div class="total-row">
          <div class="total-text">
            <span class="total-label">Total del paquete:</span>
          </div>
          <div class="total-amount-box">
            <span class="total-value">${{ selectedPkg.totalPrice | number:'1.2-2' }} <span
                class="total-currency">MXN</span></span>
          </div>
        </div>
        <p class="security-text">El pago se realizará de forma segura (SSL)</p>
        <div class="footer-actions">
          <a [routerLink]="['/guias-web']" [queryParams]="{ sku: selectedPkg.sku }" (click)="closeDetails()"
            class="btn-buy-modal">
            Comprar Pack
          </a>
        </div>
      </div>
    </div>
  </div>

</section>